// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectNumberOfGuests_wrapper__e3g7-","selectNumberOfPersonsText":"SelectNumberOfGuests_selectNumberOfPersonsText__jjp11"};